import React, { Component } from "react";

import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import ReconciliationIcon from "mdi-material-ui/ChartBar";

import { PageHeader } from "jazasoft";
import hasPrivilege from "../../../utils/hasPrivilege";
import { ResourceId, Scope } from "../../../utils/privilege";

const getReports = (roles, hasAccess) => {
  let reports = [];
  if (hasPrivilege(roles, hasAccess, ResourceId.MACRO, Scope.READ)) {
    reports.push({
      title: "FCR Report",
      icon: <ReconciliationIcon />,
      path: "/reports/macro/reconciliation"
    });
  }
  // if (hasPrivilege(roles, hasAccess, ResourceId.MACRO, Scope.READ)) {
  //   reports.push({
  //     title: "Open Order Reconciliation Report",
  //     icon: <ReconciliationIcon />,
  //     path: "/reports/macro/openOrderReconciliation"
  //   });
  // }
  if (hasPrivilege(roles, hasAccess, ResourceId.MACRO, Scope.READ)) {
    reports.push({ title: "Wastage Report", icon: <ReconciliationIcon />, path: "/reports/macro/wastage" });
  }
  if (hasPrivilege(roles, hasAccess, ResourceId.MACRO, Scope.READ)) {
    reports.push({ title: "End Bits Report", icon: <ReconciliationIcon />, path: "/reports/macro/endBits" });
  }
  if (hasPrivilege(roles, hasAccess, ResourceId.MACRO, Scope.READ)) {
    reports.push({ title: "Marker Efficiency", icon: <ReconciliationIcon />, path: "/reports/macro/markerEfficiency" });
  }
  // if (hasPrivilege(roles, hasAccess, ResourceId.MACRO, Scope.READ)) {
  //   reports.push({
  //     title: "Cut Qty Analysis Report",
  //     icon: <ReconciliationIcon />,
  //     path: "/reports/macro/cutAnalysis"
  //   });
  // }
  // if (hasPrivilege(roles, hasAccess, ResourceId.MACRO, Scope.READ)) {
  //   reports.push({
  //     title: "Roll Variation Report",
  //     icon: <ReconciliationIcon />,
  //     path: "/reports/macro/rollVariation"
  //   });
  // }

  if (hasPrivilege(roles, hasAccess, ResourceId.MACRO, Scope.READ)) {
    reports.push({
      title: "Aggregate Cutting Report",
      icon: <ReconciliationIcon />,
      path: "/reports/macro/cuttingReport"
    });
  }
  if (hasPrivilege(roles, hasAccess, ResourceId.MACRO, Scope.READ)) {
    reports.push({
      title: "Common Reports",
      icon: <ReconciliationIcon />,
      path: "/reports/macro/commonReport"
    });
  }
  // if (hasPrivilege(roles, hasAccess, ResourceId.MACRO, Scope.READ)) {
  //   reports.push({
  //     title: "Order Status Report",
  //     icon: <ReconciliationIcon />,
  //     path: "/reports/macro/orderStatus"
  //   });
  // }

  return reports;
};

const styles = {
  root: {
    margin: "1.5em"
  },
  tile: {
    padding: "1em",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    cursor: "pointer"
  },
  icon: {
    margin: "0.5em"
  },
  title: {
    margin: "0.5em",
    fontWeight: "normal"
  }
};

class MacroReport extends Component {
  render() {
    const { classes, roles, hasAccess } = this.props;
    const reports = getReports(roles, hasAccess);
    return (
      <div>
        <PageHeader title="Macro Reports" />
        <div className={classes.root}>
          <Grid container spacing={2}>
            {reports.map((report, idx) => {
              return (
                <Grid key={idx} item xs={12} sm={3}>
                  <Paper className={classes.tile} square onClick={() => this.props.history.push(report.path)}>
                    <div>
                      {React.cloneElement(report.icon, {
                        className: classes.icon,
                        style: { fontSize: 28 },
                        color: "primary"
                      })}
                    </div>
                    <Typography component="div" variant="subtitle1" className={classes.title}>
                      {report.title}
                    </Typography>
                  </Paper>
                </Grid>
              );
            })}
          </Grid>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(MacroReport);
